import { render, staticRenderFns } from "./UtmSettingsForm.vue?vue&type=template&id=78a5eb59&scoped=true"
import script from "./UtmSettingsForm.vue?vue&type=script&lang=js"
export * from "./UtmSettingsForm.vue?vue&type=script&lang=js"
import style0 from "./UtmSettingsForm.vue?vue&type=style&index=0&id=78a5eb59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a5eb59",
  null
  
)

export default component.exports